import { buildApiUrl, buildHeaders, handleResponse } from '@/network/api-client';
import type { PresenceApi, PresenceChallenge, PresenceReceipt } from '../types/presence.types';
export const presenceApi: PresenceApi = {
  async start(command, signal) {
    return handleResponse<PresenceChallenge>(await fetch(buildApiUrl('/hero/character/presence/start'), {
      method: 'POST', headers: buildHeaders(), body: JSON.stringify(command), signal,
    }));
  },
  async qualify(command, signal) {
    return handleResponse<PresenceReceipt>(await fetch(buildApiUrl('/hero/character/presence/qualify'), {
      method: 'POST', headers: buildHeaders(), body: JSON.stringify(command), signal,
    }));
  },
};
